import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const AddNote = () => {
  const { patient_id } = useParams();
  const navigate = useNavigate();

  const [note, setNote] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [messageType, setMessageType] = useState(""); // 'success', 'error', 'info'
  const API_BASE = "https://newerp.awasthivitality.com/api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("session_token") ||
    localStorage.getItem("token") ||
    "";

  return {
    Accept: "application/json",
    Authorization: token ? `Bearer ${token}` : "",
  };
};

const appendToken = (url) => {
  const token =
    localStorage.getItem("session_token") ||
    localStorage.getItem("token");

  if (!token) return url;

  try {
    const u = new URL(url);
    if (!u.searchParams.has("token")) {
      u.searchParams.append("token", token);
    }
    return u.toString();
  } catch {
    return url;
  }
};
const handleSave = async () => {
  // 1️⃣ Validate note
  if (!note.trim()) {
    setMessage("Please enter a note.");
    setMessageType("error");
    return;
  }

  setIsLoading(true);
  setMessage("");
  setMessageType("");

  try {
    const res = await axios.post(
      appendToken(`${API_BASE}/patient/notepad/add/${patient_id}`),
      {
        pdn_message: note.trim(),
      },
      {
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeaders(), // ✅ TOKEN APPLIED
        },
      }
    );

    if (res.data?.success) {
      setMessage("✅ Note saved successfully!");
      setMessageType("success");
      setNote("");

      setTimeout(() => {
        navigate("/PatientNotepad");
      }, 800);
    } else {
      setMessage(res.data?.msg || "Something went wrong.");
      setMessageType("error");
    }
  } catch (error) {
    console.error("Save note error:", error);
    setMessage("❌ Server error. Please try again.");
    setMessageType("error");
  } finally {
    setIsLoading(false);
  }
};


  const handleKeyPress = (e) => {
    if (e.key === "Enter" && e.ctrlKey) {
      handleSave();
    }
  };

  return (
    <div className="note-container">
      <div className="note-header">
        <h2>📝 Add Patient Note</h2>
        <p className="patient-info">
          Patient ID: <span className="patient-id">{patient_id}</span>
        </p>
      </div>

      <div className="note-form">
        <div className="form-group">
          <label htmlFor="note-textarea" className="form-label">
            Note Message
          </label>
          <textarea
            id="note-textarea"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Enter your note here... "
            rows={6}
            className="note-textarea"
            disabled={isLoading}
          />
          <div className="char-count">{note.length}/5000 characters</div>
        </div>

        <div className="form-actions">
          <button
            onClick={handleSave}
            className={`save-btn ${isLoading ? "loading" : ""}`}
            disabled={isLoading || !note.trim()}
          >
            {isLoading ? (
              <>
                <span className="spinner"></span>
                Saving...
              </>
            ) : (
              <>💾 Save Note</>
            )}
          </button>

          <button
            onClick={() => {
              setNote("");
              setMessage("");
              setMessageType("");
            }}
            className="clear-btn"
            disabled={isLoading}
          >
            🗑️ Clear
          </button>
        </div>

        {message && (
          <div className={`message ${messageType}`}>
            <div className="message-content">
              {message.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              ))}
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .note-container {
          max-width: 800px;
          margin: 0 auto;
          padding: 20px;
          font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
          background: linear-gradient(135deg, #66cbeaff 0%, #b199ccff 100%);
          min-height: 100vh;
          margin-left: 450px;
        }

        .note-header {
          text-align: center;
          margin-bottom: 30px;
          color: white;
        }

        .note-header h2 {
          font-size: 2.5rem;
          margin: 0 0 10px 0;
          text-shadow: 2px 2px 4px rgba(255, 255, 255, 0.3);
        }

        .patient-info {
          font-size: 1.1rem;
          margin: 0;
          opacity: 0.9;
        }

        .patient-id {
          background: rgba(255, 255, 255, 0.2);
          padding: 4px 12px;
          border-radius: 20px;
          font-weight: bold;
        }

        .note-form {
          background: white;
          border-radius: 20px;
          padding: 30px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          backdrop-filter: blur(10px);
          animation: slideUp 0.6s ease-out;
        }

        .form-group {
          margin-bottom: 25px;
        }

        .form-label {
          display: block;
          font-weight: 600;
          color: #333;
          margin-bottom: 10px;
          font-size: 1.1rem;
        }

        .note-textarea {
          width: 100%;
          padding: 15px;
          border: 2px solid #e1e5e9;
          border-radius: 12px;
          font-size: 1rem;
          font-family: inherit;
          resize: vertical;
          min-height: 150px;
          transition: all 0.3s ease;
          box-sizing: border-box;
        }

        .note-textarea:focus {
          outline: none;
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        .note-textarea:disabled {
          background-color: #f8f9fa;
          cursor: not-allowed;
        }

        .char-count {
          text-align: right;
          font-size: 0.9rem;
          color: #666;
          margin-top: 5px;
        }

        .form-actions {
          display: flex;
          gap: 15px;
          justify-content: center;
          margin-bottom: 20px;
        }

        .save-btn,
        .clear-btn {
          padding: 12px 24px;
          border: none;
          border-radius: 25px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 8px;
          min-width: 140px;
          justify-content: center;
        }

        .save-btn {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
        }

        .save-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
        }

        .save-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .clear-btn {
          background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
          color: white;
        }

        .clear-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(255, 107, 107, 0.3);
        }

        .clear-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .spinner {
          width: 16px;
          height: 16px;
          border: 2px solid transparent;
          border-top: 2px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .message {
          padding: 15px 20px;
          border-radius: 12px;
          font-weight: 500;
          white-space: pre-line;
        }

        .message.success {
          background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);
          color: white;
          border-left: 4px solid #2e7d32;
        }

        .message.error {
          background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%);
          color: white;
          border-left: 4px solid #c62828;
        }

        .message.info {
          background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
          color: white;
          border-left: 4px solid #1565c0;
        }

        .message-content {
          line-height: 1.5;
        }

        @media (max-width: 768px) {
          .note-container {
            padding: 15px;
            margin-left: 0;
          }

          .note-header h2 {
            font-size: 2rem;
          }

          .note-form {
            padding: 20px;
          }

          .form-actions {
            flex-direction: column;
          }

          .save-btn,
          .clear-btn {
            width: 100%;
          }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default AddNote;
